// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"133e99a8","239":"c760aacc","453":"99001dab","455":"16400654"}[chunkId] + ".chunk.js";
};